import { Component, OnInit } from '@angular/core';
// import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';
import { AccountService } from '../../services/account.service';

// import { CustomerModel } from '../../services/auth/customer.model';

@Component({
selector: 'app-left-navbar',
templateUrl: './left-navbar.component.html',
styleUrls: ['./left-navbar.component.scss']
})
export class LeftNavbarComponent implements OnInit {

public imageURL = 'assets/icons/icon-jssi-logo.png';
// 	public customer: CustomerModel;
// private destroy: Subject<boolean> = new Subject<boolean>();

constructor(
private authService: AuthService // ,
// private customerInfoService: CustomerInfoService,
) { }

ngOnInit(): void {
// if (this.authService.isAuthenticated()) {
// 	this.customer = this.customerInfoService.getCustomerInfo();
// }

// this.customerInfoService.customerInfoChanged.pipe(takeUntil(this.destroy)).subscribe(info => {
// 	this.customer = info;
// });
}

mouseover() {
setTimeout(() => this.imageURL = 'assets/icons/icon-jssi-horizontal-logo.png', 100);
}

mouseout() {
setTimeout(() => this.imageURL = 'assets/icons/icon-jssi-logo.png', 100);
}

logout() {
this.authService.logOut();
location.href = '/';
}

// ngOnDestroy(): void {
// this.destroy.next(true);
// this.destroy.unsubscribe();
// }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/left-navbar/left-navbar.component.ts